import { Center } from '@core/interfaces/tenant-state';

export class ResetPassword {
  email: string;
  password: string;
  password_confirmation: string;
}

export interface ApiResetPasswordResponse {
  data: {
    result: boolean; // true
    message: string; // Result message
  };
}
